import React from 'react'

interface SwitchProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const Switch: React.FC<SwitchProps> = ({
  color,
  size = 16,
  className,
  style,
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={Math.round((size * 14) / 16)}
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path
        d="M7.62226 3.28165C7.94344 3.59233 7.94344 4.10728 7.62226 4.41797C7.31576 4.71446 6.82935 4.7144 6.52292 4.41785L5.03444 2.97733L5.03388 12.4182C5.03386 12.8623 4.67388 13.2222 4.22984 13.2222C3.78577 13.2222 3.42578 12.8622 3.4258 12.4181L3.42636 2.97733L1.93677 4.41808C1.63028 4.71453 1.14392 4.71452 0.837438 4.41805C0.516208 4.10732 0.516208 3.59229 0.837436 3.28156L3.53453 0.672561C3.92219 0.297558 4.5374 0.297558 4.92507 0.672561L7.62226 3.28165ZM15.6627 9.58205C15.9838 9.89275 15.9838 10.4077 15.6626 10.7184L12.9654 13.3275C12.5778 13.7024 11.9626 13.7024 11.5749 13.3274L8.87783 10.7185C8.55661 10.4077 8.5566 9.89272 8.87781 9.58197C9.1843 9.28548 9.67069 9.28546 9.9772 9.58192L11.4668 11.0227L11.4662 1.58187C11.4661 1.13779 11.8261 0.777778 12.2702 0.777778C12.7143 0.777778 13.0742 1.13773 13.0743 1.58177L13.0748 11.0227L14.5633 9.58216C14.8697 9.28559 15.3562 9.28554 15.6627 9.58205Z"
        fill={color || '#FFFFFF'}
      />
    </svg>
  )
}
